import { useEffect, useRef, useState } from 'react';
import { grantRoomEntry, verifyRoomEntryPassword } from '../constants/roomAccess';
import './RoomPasswordGate.css';

export default function RoomPasswordGate({ open, roomName, onCancel, onSuccess }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const inputRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    setPassword('');
    setError('');
    const timer = setTimeout(() => inputRef.current?.focus(), 50);
    return () => clearTimeout(timer);
  }, [open]);

  if (!open) return null;

  const submit = () => {
    if (!verifyRoomEntryPassword(password)) {
      setError('密码错误，请重试');
      return;
    }
    grantRoomEntry();
    onSuccess?.();
  };

  return (
    <div className="room-password-overlay" role="dialog" aria-modal="true" aria-label="进入房间验证">
      <div className="room-password-card">
        <h2 className="room-password-title">进入聚会大屏</h2>
        <p className="room-password-subtitle">请输入访问密码后继续</p>
        {roomName ? <div className="room-password-room">{roomName}</div> : null}
        <input
          ref={inputRef}
          type="password"
          className="room-password-input"
          placeholder="访问密码"
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
            if (error) setError('');
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter') submit();
            if (e.key === 'Escape') onCancel?.();
          }}
        />
        {error ? <p className="room-password-error">{error}</p> : null}
        <div className="room-password-actions">
          <button type="button" className="room-password-btn" onClick={onCancel}>
            取消
          </button>
          <button type="button" className="room-password-btn room-password-btn--primary" onClick={submit}>
            进入
          </button>
        </div>
      </div>
    </div>
  );
}
